import http from "../http";

const archiveService = {

    getArchiveConcept: async() => {
        let STDDay = new Date(2022,9,29)

        const ArchiveConcept = await http.instance.get("/archivesummary/GetArchiveFStorageTransferWithDeletionBySTDDay/",{params: {STDDay: STDDay}})
        // console.log(ArchiveConcept)
        return ArchiveConcept.data;
    },

    getDashboardAnalytics: async(SelectedDate)=> {
        SelectedDate = new Date(2022,11,14)

        const archiveDashboardAnalytics = await http.instance.get("/archivesummary/GetArchiveStorageTransferAnalytics/",{params: {SelectedDate: SelectedDate}})
        // console.log("Service getDashboardAnalytics")
        // console.log(archiveDashboardAnalytics.data)
        return archiveDashboardAnalytics.data;
    }



}
export default archiveService
